import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { CustomizedLabels, Quotes } from '@models/models';
import { Subject } from 'rxjs';
import { SettingsProvider } from '@services/settings/settings';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'quote-view-fixed',
	template: require('./quote-view-fixed.html'),
	styles: [require('./quote-view-fixed.scss')]
})
export class QuoteViewFixedComponent implements OnInit, OnDestroy {
	@Input() products;
	@Input('company') company: any;
	@Input('isClientPortal') isClientPortal = false;
	@Input('data') data: Quotes;
	@Input('imgSrc') imgSrc = '';
	@Input('userCurrencySymbol') userCurrencySymbol: any;

	businessNumberLabelName: string;

	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(private settingsService: SettingsProvider) {}

	ngOnInit(): void {
		this.subscribeToCustomizeLabelsChange();
	}

	ngOnDestroy() {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	private subscribeToCustomizeLabelsChange(): void {
		this.settingsService.customizeLabelsObservable
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(customizeLabels: CustomizedLabels): string =>
					(this.businessNumberLabelName = customizeLabels.businessNumberLabel)
			);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/quote/quote-view-fixed/quote-view-fixed.ts